module.exports = "/_next/static/images/ba09740d9fc617ceb593bb1791ad59fd-secured-icon-new.svg.webp";